export const BACKUP = 'backup'

export const ENDPOINTS = {
  GET_LOGS: `/${BACKUP}/logs`,
  TRIGGER_BACKUP: `/${BACKUP}/trigger`,
  GET_BACKUP_STATUS: `/${BACKUP}/status`,
  GET_BACKUP_FILES_STATUS: `/${BACKUP}/files-status`,
  DOWNLOAD_FILE: `/${BACKUP}/download`,
}
